import { Title, Subtitle, Body, Bold } from '@panwds/react-ui'
import DividerLine from './DividerLine'
import type { ReactNode } from 'react'
import styled from 'styled-components'

export interface IKeyValueDisplayProps {
  title: string
  subTitle?: string
  data: DataType
  showBottomDivider?: boolean
  showTopDivider?: boolean
}

export type DataTypeEntry = {
  label: string
  value: string | number | ReactNode | undefined | null
  hideLabel?: boolean
}

export type DataType = DataTypeEntry[]


const DisplayWrapper = styled.div`
  display:flex;
  flex-direction:row;
  p {
    margin-bottom : 0px !important;
    padding-bottom: 0px !important;
    font-size: 12px !important;
  }
  `

const KeyValueDisplay = (props: IKeyValueDisplayProps) => {
  const { title, subTitle, data, showBottomDivider, showTopDivider } = props
  return (
    <div>
      {showTopDivider && <DividerLine />}
      <div className='tw-flex tw-flex-col'>
        <Title size='xxs' level={2} addClassName='cm-mb-[12px]'>{title}</Title>
        <Subtitle>{subTitle}</Subtitle>
        {data.map((item, index) => (
          <DisplayWrapper key={index}>
            {!Boolean(item?.hideLabel) && <Body size='xs' as='div' className='cm-mr-[4px]'><Bold>{item.label}</Bold>:</Body>}
            <Body size='xs' as='div' className='tw-mr-1 dark:tw-text-white'>{item.value}</Body>
          </DisplayWrapper>
        ))}
      </div>
      {showBottomDivider && <DividerLine />}
    </div>
  )
}

export default KeyValueDisplay
